import dayjs from "dayjs";
import "dayjs/locale/ar";
import OrphanForm from "./OrphanForm";
import { useEffect, useState } from "react";
import { Collapse } from "antd";
import userIcon from "../../../../assets/icons/user.svg";
import { OrphanModel } from "../models/Orphan";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";

const { Panel } = Collapse;
interface ChildrenProps {
  nationality: any;
  identificationTypes: any;
  maritalStatus: any;
  form: any;
  parentForm: any;
}

dayjs.locale("ar");

const ChildrenForm = ({
  nationality,
  maritalStatus,
  identificationTypes,
  form,
  parentForm,
}: ChildrenProps) => {
  const [active, setActive] = useState<any>("0");
  const [orphans, setOrphans] = useState<OrphanModel[]>([
    {
      firstname: "",
      father_name: parentForm.getFieldValue(`father_firstname`),
      grandfather_name: parentForm.getFieldValue(`father_father_name`),
      family_name: parentForm.getFieldValue(`father_family_name`),
      eng_name: "",
      gender: "",
      birthday: "",
      nationality_id: "",
      marital_status_id: -1,
      email: "",
      phone: "",
      mobile: "",
      identification_type_id: -1,
      identification_number: "",
      identification_source: "",
      identification_date: "",
      identify_image_ids: [
        {
          filename: "",
          data: "",
        },
      ],
      identification_deadline: "",
      defaultFile: [],
    },
  ]);

  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], index: number) => {
    const file: any = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = (await convertFileToBase64(file)) as string;
        const imageData = {
          filename: file.name,
          data: base64,
        };
        const updatedBlocks = [...orphans];
        updatedBlocks[orphans.length - 1].identify_image_ids = [imageData];
        updatedBlocks[index].defaultFile = fileList;
        setOrphans(updatedBlocks);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  /* handle the data in the form */
  useEffect(() => {
    const beneficiaryOrphanStateData = orphans.map((block, index) => ({
      firstname: block.firstname,
      father_name: block.father_name,
      grandfather_name: block.grandfather_name,
      family_name: block.family_name,
      eng_name: block.eng_name,
      gender: block.gender,
      birthday: block.birthday,
      nationality_id: block.nationality_id,
      marital_status_id: block.marital_status_id,
      email: block.email,
      phone: block.phone,
      mobile: block.mobile,
      identification_type_id: block.identification_type_id,
      identification_number: block.identification_number,
      identification_source: block.identification_source,
      identification_date: block.identification_date,
      identify_image_ids: block.identify_image_ids,
      identification_deadline: block.identification_deadline,
    }));

    form.setFieldValue("beneficiary_orphan_ids", beneficiaryOrphanStateData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orphans]);

  const onChange = (value: any, key: keyof OrphanModel, index: number) => {
    const l__bloks: any[] = [...orphans];

    if (
      key === "nationality_id" ||
      key === "marital_status_id" ||
      key === "identification_type_id"
    ) {
      l__bloks[index][key] = value.value;
    } else if (
      key === "birthday" ||
      key === "identification_date" ||
      key === "identification_deadline"
    ) {
      l__bloks[index][key] = value ? value.format("YYYY-MM-DD") : null;
    } else if (key === "gender") {
      if (value.value === 1) {
        l__bloks[index][key] = "male";
      } else {
        l__bloks[index][key] = "female";
      }
    } else {
      l__bloks[index][key] = value;
    }

    setOrphans(l__bloks);
  };

  const toAddOrphan = () => {
    setOrphans([
      ...orphans,
      {
        firstname: "",
        father_name: parentForm.getFieldValue(`father_firstname`),
        grandfather_name: parentForm.getFieldValue(`father_father_name`),
        family_name: parentForm.getFieldValue(`father_family_name`),
        eng_name: "",
        gender: "",
        birthday: "",
        nationality_id: "",
        marital_status_id: -1,
        email: "",
        phone: "",
        mobile: "",
        identification_type_id: -1,
        identification_number: "",
        identification_source: "",
        identification_date: "",
        identify_image_ids: [
          {
            filename: "",
            data: "",
          },
        ],
        identification_deadline: "",
        defaultFile: [],
      },
    ]);

    setActive(orphans.length);
  };

  // Remove an orphan
  const removeOrphan = (index: number) => {
    const updatedOrphans = orphans.filter((_, i) => i !== index);
    const json: any = {};

    updatedOrphans.forEach((item, i) => {
      let selectedCountry: any;
      let selectedMaritalStatus: any;
      let selectedIdentificationType: any;
      if (item.nationality_id !== "-1" && item.nationality_id !== "") {
        const n = nationality?.data.filter(
          (el: any) => el.id === item.nationality_id
        )[0];
        selectedCountry = {
          key: n.id,
          label: n.name,
          value: n.id,
        };
      }
      if (item.marital_status_id !== -1) {
        const n = maritalStatus?.data.filter(
          (el: any) => el.id === item.marital_status_id
        )[0];
        selectedMaritalStatus = {
          key: n.id,
          label: n.name,
          value: n.id,
        };
      }

      if (item.identification_type_id !== -1) {
        const n = identificationTypes?.data.filter(
          (el: any) => el.id === item.identification_type_id
        )[0];
        selectedIdentificationType = {
          key: n.id,
          label: n.name,
          value: n.id,
        };
      }

      json["firstname" + i] = item.firstname;
      json["father_name" + i] = item.father_name
        ? item.father_name
        : parentForm.getFieldValue(`father_firstname`);
      json["grandfather_name" + i] = item.grandfather_name
        ? item.grandfather_name
        : parentForm.getFieldValue(`father_father_name`);
      json["family_name" + i] = item.family_name
        ? item.family_name
        : parentForm.getFieldValue(`father_family_name`);
      json["eng_name" + i] = item.eng_name;
      json["gender" + i] =
        // eslint-disable-next-line eqeqeq
        item.gender == "male"
          ? {
              key: 1,
              label: "ذكر",
              value: 1,
            }
          // eslint-disable-next-line eqeqeq
          : item.gender == "female"
          ? {
              key: 2,
              label: "أنثى",
              value: 2,
            }
          : "";
      json["birthday" + i] = item.birthday ? dayjs(item?.birthday) : null;
      json["nationality_id" + i] = selectedCountry;
      json["marital_status_id" + i] = selectedMaritalStatus;
      json["email" + i] = item.email;
      json["phone" + i] = item.phone;
      json["mobile" + i] = item.mobile;
      json["identification_type_id" + i] = selectedIdentificationType;
      json["identification_number" + i] = item.identification_number;
      json["identification_source" + i] = item.identification_source;
      json["identification_date" + i] = item.identification_date
        ? dayjs(item?.identification_date)
        : null;
      json["identify_image_ids" + i] = item.identify_image_ids;
      json["identification_deadline" + i] = item.identification_deadline
        ? dayjs(item?.identification_deadline)
        : null;
    });
    form.resetFields();
    form.setFieldsValue(json);
    setOrphans([...updatedOrphans]);
    setActive(updatedOrphans.length - 1);
  };

  return (
    <>
      <div className="takaful--title-tabs-main">
        <span>الأفراد اللذين يسكنون مع الأرملة بالمنزل</span>
      </div>
      <div className="takaful--title-tabs-sub">
        <span>معلومات عن الأبناء</span>
      </div>
      <Collapse
        className="takaful--collapse-recipient"
        accordion
        activeKey={active}
        onChange={(key) => setActive(key)}
      >
        {orphans.map((el: any, key) => (
          <>
            <Panel
              className="takaful--header-recipient-Panel takaful--header-radius"
              key={key}
              header={
                <div className="takaful--header-recipient-container">
                  <div className="takaful--header-recipient-collapse">
                    <img src={userIcon} alt="userIcon" className="userIcon" />
                    <span className="takaful--add-recipient-title">
                      {el.firstname !== "" ? el.firstname : `فرد ${key + 1}`}
                    </span>
                  </div>
                </div>
              }
              extra={
                orphans.length > 1 && (
                  <PrimaryButton
                    icon={
                      <DeleteOutlined
                        style={{ fontSize: "1rem", color: "black" }}
                      />
                    }
                    onClick={() => removeOrphan(key)}
                    title=""
                    className="takaful--primary-button-light"
                  />
                )
              }
            >
              <OrphanForm
                parentForm={parentForm}
                onChange={(value: any, key: keyof OrphanModel, index: number) =>
                  onChange(value, key, index)
                }
                handleFileChange={(fileList: any[]) =>
                  handleFileChange(fileList, key)
                }
                defaultFile={el.defaultFile}
                form={form}
                index={key}
                nationality={nationality}
                maritalStatus={maritalStatus}
                identificationTypes={identificationTypes}
                item={el}
              />
            </Panel>
          </>
        ))}
      </Collapse>

      <div className="takaful--add-child-button">
        <PrimaryButton
          title={"إضافة فرد"}
          icon={<PlusCircleOutlined />}
          className="takaful--primary-button-prev"
          onClick={() => toAddOrphan()}
        />
      </div>
    </>
  );
};

export default ChildrenForm;
